'use client';
import Link from "next/link"
import { MenuList } from "./menu";
import { SupportLink } from "./supportLink";
import { SearchBar } from "./search";
import { Logo } from "./Logo";

export const Header = () => {
    return (
        <div className="shadow-3 surface-0 border-bottom-1 border-300	header">

            <div className="container flex align-items-center justify-content-between">
                <div className="flex  align-items-center gap-3 w-30rem logo">
                    <Link className="cursor-pointer flex-column flex p-2 pb-1 pt-1 gap-3 align-items-center text-900" href={'/'} >
                        <Logo height={35} />
                        <span style={{ fontWeight: '600', fontSize:'0.6rem' }} className="-mt-3">Smart Living Starts with Ennix</span>

                    </Link>
                </div>

                <div className="flex align-items-center gap-1">
                    <SearchBar />
                    <SupportLink />
                    <MenuList />
                </div>
            </div>
        </div>
    )
}